import { render, staticRenderFns } from "./ptcEdit.vue?vue&type=template&id=7fa1ec82&scoped=true&"
import script from "./ptcEdit.vue?vue&type=script&lang=js&"
export * from "./ptcEdit.vue?vue&type=script&lang=js&"
import style0 from "./ptcEdit.vue?vue&type=style&index=0&id=7fa1ec82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1ec82",
  null
  
)

export default component.exports